/**
 * Image Gallery — GLightbox integration
 *
 * Initializes GLightbox for all .b-image-gallery[data-lightbox] elements.
 * Images are grouped per gallery via data-gallery="{galleryId}" on each <a>,
 * so clicking an image navigates only within that gallery's set.
 *
 * Expects the following markup on each lightbox trigger:
 *   <a class="b-image-gallery__link"
 *      href="{full-size-url}"
 *      data-gallery="gallery-{uid}"
 *      data-title="{image.title}"
 *      data-description="{image.description}">
 */
import GLightbox from "glightbox";

/** @type {import('glightbox').GlightboxObject | null} */
let lightboxInstance = null;

/**
 * Initialize GLightbox for all galleries on the page.
 * A single shared instance handles grouping automatically
 * via the data-gallery attribute on each anchor element.
 */
export function initGallery() {
    const links = document.querySelectorAll(".b-image-gallery__link");
    if (!links.length) return;

    lightboxInstance = GLightbox({
        selector: ".b-image-gallery__link",
        touchNavigation: true,
        loop: true,
        zoomable: false,      // disable pinch-zoom inside lightbox (keeps UI clean)
        draggable: true,
        openEffect: "zoom",
        closeEffect: "zoom",
        slideEffect: "slide",
        keyboardNavigation: true,
        closeOnOutsideClick: true,
        plyr: {
            css: "",
            js: "",
        },
    });
}

/**
 * Destroy the lightbox instance (used by HMR and cleanup).
 */
export function destroyGallery() {
    if (lightboxInstance) {
        lightboxInstance.destroy();
        lightboxInstance = null;
    }
}
